var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17187 10.3566C6.94364 11.9504 8.23239 13.2358 9.82812 14.0035C9.94583 14.0593 10.076 14.0834 10.2059 14.0735C10.3358 14.0637 10.4608 14.0201 10.5687 13.9473L12.9125 12.3816C13.016 12.3114 13.1357 12.2686 13.2603 12.2571C13.3849 12.2456 13.5104 12.2659 13.625 12.316L18.0125 14.2004C18.1625 14.2628 18.2877 14.3728 18.369 14.5134C18.4504 14.654 18.4832 14.8174 18.4625 14.9785C18.3234 16.0639 17.7937 17.0614 16.9723 17.7844C16.1509 18.5074 15.0943 18.9064 14 18.9066C10.6185 18.9066 7.37548 17.5633 4.98439 15.1723C2.5933 12.7812 1.25 9.53816 1.25 6.15665C1.25025 5.06239 1.6492 4.00572 2.37221 3.18436C3.09522 2.36299 4.09274 1.83321 5.17812 1.69415C5.33922 1.67345 5.50266 1.70629 5.64326 1.7876C5.78386 1.86892 5.89384 1.99419 5.95625 2.14415L7.84062 6.54102C7.88963 6.65385 7.91013 6.77699 7.90032 6.89961C7.89051 7.02223 7.85069 7.14055 7.78437 7.24415L6.21875 9.6254C6.14905 9.7331 6.10814 9.85688 6.09993 9.98491C6.09172 10.1129 6.11649 10.2409 6.17187 10.3566V10.3566Z",
    stroke: "#5A5B5D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4b595697b9ea302fc6175e829f1140ed.svg";
export { ForwardRef as ReactComponent };